function getFilterTagSets(params){
  const strFilterByTags = params.get('filter_by_tags');
  if(!strFilterByTags)return [new Set()];

  return strFilterByTags.split(':').map(it => new Set(it.split(',')));
}

function redirect(params, filterTagSets){
  params.set('filter_by_tags', filterTagSets.map(it => [...it.values()].join(',')).filter(it=>it !== '').join(':'));
  window.location.href= window.location.pathname + "?" + params.toString().replaceAll('%2C', ',').replaceAll('%3A', ':') + '#project-list';
}

function removeTag(element){
  const tagId = element.getAttribute('data-tag-id');
  const params = new URLSearchParams(window.location.search);

  const filterTagSets = getFilterTagSets(params);
  filterTagSets.forEach(it => it.delete(tagId));

  redirect(params, filterTagSets);
}

function addTag(element){
  const tagId = element.getAttribute('data-tag-id');
  let params = new URLSearchParams(window.location.search);
  const filterTagSets = getFilterTagSets(params);
  filterTagSets[0].add(tagId);

  redirect(params, filterTagSets);
}

document.querySelectorAll('.tools .filter-tag').forEach(el => el.addEventListener('click', evt => removeTag(evt.currentTarget)));

document.querySelectorAll('ul.tags > li').forEach(el => el.addEventListener('click', evt => addTag(evt.currentTarget)));